/*
 * Inits builder showcase utils for sections.
 */
define('builderShowcaseSectionsUtils',[
  'lazyLoad',
  'marqueeGalleryHandler',
  'marqueeFilmstripHandler',
  'marqueeArrowsHandler',
  'builderShowcaseObserver',
  'builderShowcaseVideoHandler',
  'marqueeFirstElementInitializer',
  'builderShowcaseIframeHandler',
  'marqueeTabsHandler',
  'marqueeArrowsHandler',
  'reviewsHandler',
  'sectionLazyLoad',
  'builderShowcaseGalleryDownloader',
  'nearbySectionHandler',
  'arrowHandler',
  'askQuestionLoader',
], (
  lazyLoad,
  MarqueeGalleryHandler,
  MarqueeFilmstripHandler,
  MarqueeArrowsHandler,
  builderShowcaseObserver,
  VideoHandler,
  marqueeFirstElementInitializer,
  IframeHandler,
) => {
  'use strict';

  const nearbyContainer = document.querySelector('[data-nearbySection-container]');

  lazyLoad.init();

  function SectionUtils() {

  }

  /**
    * @private
    * getCollection: gets the collection of the selected image.
    */
  function getCollection(state, subCollection) {
    const data = state.data.galleryCollections;
    const parameter = `${subCollection.toLowerCase()}Collection`;
    return data[parameter];
  }

  /**
    * @private
    * configObject: gets the config object to use in the filmstrip and main viewer.
    */
  const configObject = {
    filmstripItems: document.querySelectorAll('[data-filmstrip-figure]'),
    mainViewer: document.querySelector('[data-component="marquee-main-view"]'),
    firstActiveImage: document.querySelector('[data-component="marquee-filmstrip"] [data-filmstrip-image]'),
    getGalleryCollection: getCollection,
    eventOnImageSelected: builderShowcaseObserver.imageSelected,
    activeThumbSelector: '[data-filmstrip-image]',
    componentName: 'marqueeGallery',
    navigationButtons: document.querySelectorAll('[data-filmstrip-button]'),
    eventOnThumbSelected: builderShowcaseObserver.navigateToImage,
  };

  const videoHandler = new VideoHandler(configObject);
  const iframeHandler = new IframeHandler(configObject);
  const marqueeHandler = new MarqueeGalleryHandler(configObject);
  const marqueeFilmstrip = new MarqueeFilmstripHandler(configObject);
  (() => new MarqueeArrowsHandler(configObject))();

  SectionUtils.update = function update(data, topic) {
    if (topic === 'onImageSelected') {
      marqueeHandler.update(data);
      videoHandler.update(data);
      iframeHandler.update(data);
    }

    if (topic === 'onNavigateToImage') {
      marqueeFilmstrip.update(data);
    }

    if (topic === 'onGalleryClosed') {
      marqueeFilmstrip.update(data, 'onGalleryClosed');
    }
  };

  /**
    * @private
    * loads the drivingDirectionsHandler.js module if the users clicks on the getdriving directions button.
    */
  function loadDrivingDirectionsModule(event) {
    if ('communityDrivingDirections' in event.target.dataset) {
      nearbyContainer.removeEventListener('click', loadDrivingDirectionsModule);
      require(
        ['drivingDirectionsHandler'],
        (drivingDirectionsHandler) => {
          drivingDirectionsHandler.init();
          drivingDirectionsHandler.openDirectionsOnMap(event.target);
        }
      );
      event.preventDefault();
    }
  }

  function attachArrowEvent() {
    const communityCards = document.querySelectorAll('[data-nearby-community]');

    communityCards.forEach((community) => {
      (() => new window.NewHomeSource.Modules.ArrowHandler({
        container: community
      }))();
    });
  }

  if (nearbyContainer) {
    nearbyContainer.addEventListener('click', loadDrivingDirectionsModule);
  }

  builderShowcaseObserver.subscribe('onImageSelected', SectionUtils);
  builderShowcaseObserver.subscribe('onNavigateToImage', SectionUtils);
  builderShowcaseObserver.subscribe('onGalleryClosed', SectionUtils);

  marqueeFirstElementInitializer.initializeFirstElement(configObject);
  attachArrowEvent();
});

